<template>
  <b-modal
    ref="notificacaoModal"
    class="w-100"
    title="Cadastro de Notificação"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    size="lg"
  >
    <template #modal-header>
      <b-button
        variant="none"
        class="btn-none rounded-pill icone-acao"
        @click="fechar"
      >
        <font-awesome-icon
          :icon="['fas', 'xmark']"
          size="xl"
          color="var(--primary)"
        />
      </b-button>
    </template>
    <cadastro-base
      :is-modal="true"
      :salvar="salvar"
      :cancelar-cadastro="fechar"
    >
      <template slot="conteudo">
        <b-row>
          <b-col cols="12">
            <b-form-group label="Título">
              <b-form-input v-model="form.titulo" placeholder="Titulo da notificação, você também pode utilizar placeholders aqui!"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group label="Descrição da Notificação">
              <b-form-textarea
                v-model="form.descricao"
                rows="3"
                placeholder='Descreva a notificação aqui, é obrigatório. Apenas as primeiras 90 letras serão exibidas na tela de listagem. Você pode usar placeholders como para personalizar a mensagem.'
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Evento gatilho de Notificação -->
        <b-row>
          <b-col cols="12">
            <b-form-group label="Evento gatilho de Notificação">
              <div class="d-flex">
                <b-form-select
                  v-model="form.eventoNotificacaoId"
                  :options="eventosNotificacao"
                  @click="buscaEventosNotificacao"
                  @focus="handleFocus"
                  class="flex-grow-1"
                />
                <b-button
                  variant="outline-secondary"
                  size="sm"
                  class="ml-2"
                  @click="buscaEventosNotificacao"
                  v-b-tooltip.hover
                  title="Recarregar opções"
                >
                  <font-awesome-icon :icon="['fas', 'arrows-rotate']" />
                </b-button>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Tipo de notificacao -->
        <b-row>
          <b-col cols="12">
            <b-form-group label="Tipo de Notificação">
              <div class="d-flex">
                <b-form-select
                  v-model="form.tipo"
                  :options="tiposNotificacao"
                  @click="buscaTipoNotificacao"
                  class="flex-grow-1"
                />
                <b-button
                  variant="outline-secondary"
                  size="sm"
                  class="ml-2"
                  @click="buscaTipoNotificacao"
                  v-b-tooltip.hover
                  title="Recarregar opções"
                >
                  <font-awesome-icon :icon="['fas', 'arrows-rotate']" />
                </b-button>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Exibir placeholders desse evento -->
        <b-row v-if="form.eventoNotificacaoId">
          <b-col cols="12">
            <b-link
              href="#"
              @click.prevent="showPlaceholders = !showPlaceholders"
              class="text-primary"
            >
              Exibir placeholders desse evento
            </b-link>
            <b-collapse v-model="showPlaceholders" class="mt-2">
              <b-card>
                <b-list-group>
                  <b-list-group-item
                    v-for="placeholder in placeholders"
                    :key="placeholder.id"
                    @click="insertPlaceholder(placeholder)"
                    class="cursor-pointer"
                  >
                    {{ placeholder.codigo }} - {{ placeholder.descricao }}
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-collapse>
          </b-col>
        </b-row>

    <!-- Grupo de notificação -->
        <b-row>
          <b-col cols="12">
            <grupo-notificacao-select
              v-model="form.gruposNotificacao"
              :require-grupo="true"
              multiple
            />
          </b-col>
        </b-row>

        <!-- Mensagem da notificação -->
        <b-row>
          <b-col cols="12 mt-2">
            <b-form-group label="Mensagem">
              <div class="editor-container">
                <quill-editor
                  ref="quillEditor"
                  v-model="form.mensagem"
                  :options="editorOptions"
                />
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </cadastro-base>
  </b-modal>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from '@/app-modulo/comuns/notificacao/shared/services/api'
import GrupoNotificacaoSelect from '@/app-modulo/comuns/notificacao/shared/components/GrupoNotificacaoSelect.vue'

export default {
  name: 'NotificacaoModal',
  components: {
    FontAwesomeIcon,
    CadastroBase,
    quillEditor,
    GrupoNotificacaoSelect,
  },
  data() {
    return {
      form: {
        titulo: '',
        mensagem: '',
        descricao: '',
        tipo: '',
        gruposNotificacao: [],
        eventoNotificacaoId: null,
        ativo: true,
      },
      eventosNotificacao: [],
      tiposNotificacao: [],
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            ['image'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
          ],
        },
        placeholder: [
          'Escreva sua mensagem aqui...',
          'Você pode adicionar imagens, links e formatação de texto.',
          'Use as opções de formatação acima para personalizar sua mensagem.',
        ],
      },
      placeholders: [],
      showPlaceholders: false,
    }
  },
  watch: {
    'form.eventoNotificacaoId': function eventoNotificacaoIdWatcher(newValue) {
      if (newValue) {
        this.updatePlaceholders()
      } else {
        this.placeholders = []
      }
    },
  },
  mounted() {
    this.buscaEventosNotificacao()
    this.buscaTipoNotificacao()
  },
  methods: {
    fechar() {
      this.$refs.notificacaoModal.hide()
    },
    abrir(id = null) {
      if (id) {
        // Buscar os dados do registro pelo ID
        api.getNotificacaoById(id)
          .then(response => {
            this.form = { ...response.data }
            this.form.eventoNotificacaoId = response.data.eventoNotificacao.id
            this.$refs.notificacaoModal.show()
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response.statusText !== '' ? err.response.statusText : (err.response.data.message || err.message),
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            })
          })
      } else {
        // Resetar o formulário para criação
        this.form = {
          titulo: '',
          mensagem: '',
          descricao: '',
          tipo: '',
          gruposNotificacao: [],
          eventoNotificacaoId: null,
          ativo: true,
        }
        this.$refs.notificacaoModal.show()
      }
    },
    salvar() {
      return new Promise((resolve, reject) => {
        if (!this.form.titulo || !this.form.mensagem || !this.form.eventoNotificacaoId) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Preencha todos os campos para prosseguir!',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
          reject()
        } else {
          const apiCall = this.form.id
            ? api.atualizaNotificacao(this.form.id, this.form) // Atualização
            : api.criaNotificacao(this.form) // Criação

          apiCall
            .then(() => {
              this.fechar()
              this.$emit('notification-saved', this.form)
              this.form = {
                id: null,
                titulo: '',
                mensagem: '',
                descricao: '',
                tipo: '',
                gruposNotificacao: [],
                eventoNotificacaoId: null,
                ativo: true,
              }
              resolve('Notificação salva com sucesso!')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    buscaEventosNotificacao() {
      api.getEventosNotificacoes()
        .then(payload => {
          this.eventosNotificacao = payload.data.map(evento => ({
            text: evento.nome,
            value: evento.id,
          }))
        }).catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: err.response.statusText !== '' ? err.response.statusText : (err.response.data.message || err.message),
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
        })
    },
    buscaTipoNotificacao() {
      api.getTiposNotificacao()
        .then(payload => {
          this.tiposNotificacao = payload.data.map(tipo => ({
            text: tipo.nome,
            value: tipo.valor,
          }))
        }).catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: err.response.statusText !== '' ? err.response.statusText : (err.response.data.message || err.message),
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
        })
    },
    handleFocus() {
      // Exibir os placeholders disponíveis quando o campo de evento recebe foco
      this.showPlaceholders = true
      this.updatePlaceholders()
    },
    updatePlaceholders() {
      // Atualizar placeholders com base no evento selecionado
      const selectedEventId = this.form.eventoNotificacaoId
      if (selectedEventId) {
        // Buscar o evento específico para obter os placeholders completos
        api.getEventoNotificacaoPlaceholders(selectedEventId)
          .then(payload => {
            this.placeholders = payload.data.map(placeholder => ({
              id: placeholder.id,
              codigo: placeholder.codigo,
              descricao: placeholder.descricao,
            }))
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response.statusText !== '' ? err.response.statusText : (err.response.data.message || err.message),
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            })
          })
      } else {
        this.placeholders = []
      }
    },
    insertPlaceholder(placeholder) {
      // Inserir o placeholder no editor
      const editor = this.$refs.quillEditor.quill
      if (editor) {
        const range = editor.getSelection(true)
        editor.insertText(range.index, `{{${placeholder.codigo}}}`, 'user')
        this.showPlaceholders = false
      }
    },
  },
}
</script>

<style src="@core/scss/vue/libs/quill.scss" lang="scss"></style>
<style lang="scss">
.ql-editor {
  overflow: auto;
  min-height: 300px;
  max-height: 700px;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfbfbf;
  }
}

.suggestions-dropdown {
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  z-index: 1000;
  max-height: 150px;
  overflow-y: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.suggestions-dropdown ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.suggestions-dropdown li {
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.suggestions-dropdown li:hover {
  background: #f0f0f0;
}

.suggestions-dropdown li.active {
  background: #e8f0fe;
  color: #1a73e8;
}

.placeholder-label {
  padding: 5px 10px;
  font-size: 12px;
  font-weight: bold;
  color: #666;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.editor-container {
  position: relative;

  .ql-editor {
    min-height: 250px;
    max-height: 500px;
    overflow-y: auto;
  }

  .placeholder-dropdown {
    position: absolute;
    width: 250px;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    top: 50px;
    left: 0;

    .placeholder-title {
      padding: 8px 12px;
      background: #f5f5f5;
      border-bottom: 1px solid #ddd;
      font-weight: bold;
      color: #555;
    }

    .placeholder-item {
      padding: 8px 12px;
      cursor: pointer;

      &:hover {
        background: #f0f0f0;
      }
    }
  }
}
</style>
